document.addEventListener('click', function (e) {
  var pill = e.target.closest('.nb-size-pill');
  if (!pill || pill.disabled) return;
  e.preventDefault();
  var variantId = pill.getAttribute('data-variant-id');
  if (!variantId || !window.essentialCartApi) return;
  pill.classList.add('is-loading');
  window.essentialCartApi.addItem(parseInt(variantId, 10), 1)
    .then(function () {
      pill.classList.remove('is-loading');
      pill.classList.add('is-added');
      setTimeout(function () {
        pill.classList.remove('is-added');
      }, 1500);
      if (window.essentialCartApi.openCart) {
        window.essentialCartApi.openCart();
      }
    })
    .catch(function (err) {
      pill.classList.remove('is-loading');
      console.error('nb-size-pill add error', err);
    });
});
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.nb-sc__prod-arrow');
  if (!btn) return;
  var viewport = btn.closest('.nb-sc__viewport');
  if (!viewport) return;
  var track = viewport.querySelector('.nb-sc__track');
  if (!track) return;
  var amount = track.clientWidth;
  track.scrollBy({ left: btn.classList.contains('nb-sc__prod-arrow--prev') ? -amount : amount, behavior: 'auto' });
  });
document.addEventListener('click', function (e) {
  var proxy = e.target.closest('.js-filter-proxy-toggle');
  if (!proxy) return;
  var filterBtn = document.querySelector('[data-show-collection-filter]');
  var panel = document.querySelector('.cc-product-filter');
  var alreadyOpen = panel && panel.classList.contains('-in');

  if (proxy.tagName === 'BUTTON') {
    // "Ordenar" button: open the drawer only if it's closed (never toggle it
    // closed from here), then open + scroll to the "Ordenar por" section.
    if (filterBtn && !alreadyOpen) filterBtn.click();
    setTimeout(function () {
      var sortItem = null;
      document.querySelectorAll('.cc-product-filter .cc-accordion-item').forEach(function (item) {
        var titleEl = item.querySelector('.cc-accordion-item__title');
        if (titleEl && /ordenar/i.test(titleEl.textContent)) {
          sortItem = item;
        }
      });
      if (sortItem) {
        sortItem.open = true;
        sortItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, alreadyOpen ? 0 : 350);
  } else {
    // Overlay click: just close the drawer as before.
    if (filterBtn) filterBtn.click();
  }
});

// Shopify's own "Draft" preview bar (only shown while viewing a
// preview_theme_id link, never on the published site) sits fixed at the
// bottom of the screen and can visually cover the mobile filter buttons
// above, which are also fixed to the bottom. This measures that bar (if
// present) and shifts the filter buttons/drawer up by its height so they
// never overlap during preview. In production the bar never exists, so
// this always resolves to 0px and changes nothing.
(function () {
  function applyPreviewBarOffset() {
    var bar = document.getElementById('PBarNextFrameWrapper') || document.getElementById('PBarNextFrame');
    var h = bar ? Math.ceil(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--nb-preview-bar-h', h + 'px');
  }
  applyPreviewBarOffset();
  [100, 500, 1500, 3000].forEach(function (ms) {
    setTimeout(applyPreviewBarOffset, ms);
  });
  window.addEventListener('resize', applyPreviewBarOffset);
  var previewBarObserver = new MutationObserver(applyPreviewBarOffset);
  previewBarObserver.observe(document.body, { childList: true });
})();